import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-loading-card',
  host: {
    '[style.display]': 'type == "post-gallery" ? "flex" : "block"',
    '[style.column-gap]': 'type == "post-gallery" ? "1rem" : "0"',
  },
  templateUrl: './loading-card.component.html',
  styleUrl: './loading-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingCardComponent {
  @Input() type: 'post' | 'widget' | 'post-gallery';
  @Input() count: number = 5;
  @Input() animationEnabled: boolean = true;
}
